module.exports = __webpack_public_path__ + "8ce144cbabf93214f0011e4d0ebfd79a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1557132315021
// module id = 15
// module chunks = 0